// assets/shipping-perk-banner.js
(function () {
  if (window.__shippingPerkInitializedJPY) return;
  window.__shippingPerkInitializedJPY = true;

  // 日本円（整数・3桁区切り + '円'）
  function formatJPY(cents) {
    var yen = Math.round((typeof cents === 'number' ? cents : 0) / 100);
    return yen.toLocaleString('ja-JP') + '円';
  }

  function clampToZero(n) { return n > 0 ? n : 0; }

  function renderBanner(el, total) {
    if (!el) return;
    var FREE = parseInt(el.getAttribute('data-free-threshold'), 10) || 0;
    var HALF = parseInt(el.getAttribute('data-half-threshold'), 10) || 0;

    var needHalf = HALF - total;
    var needFree = FREE - total;

    var html = '';
    if (total >= FREE) {
      html = '<p style="margin:0;font-weight:600;">🎉 現在 <strong><span class="red">送料無料</span></strong> です！</p>';
    } else if (total >= HALF) {
      html = '<p style="margin:0;">現在 <strong><span class="red">送料半額</span></strong> です。<br>あと<strong><span class="red">'
           + formatJPY(clampToZero(needFree))
           + '</span></strong>で <strong><span class="red">送料無料</span></strong> です。</p>';
    } else {
      html = '<p style="margin:0;">あと<strong><span class="red">'
           + formatJPY(clampToZero(needHalf))
           + '</span></strong>追加で <strong><span class="red">送料半額</span></strong>、<br><strong><span class="red">'
           + formatJPY(clampToZero(needFree))
           + '</span></strong>追加で <strong>送料無料</strong> になります。</p>';
    }
    el.innerHTML = html;
  }

  function refreshAllBanners() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
        document.querySelectorAll('.shipping-perk-banner').forEach(function (el) {
          renderBanner(el, total);
        });
      })
      .catch(function () {
        // 失敗時はLiquidが埋め込んだ初期totalで描画
        document.querySelectorAll('.shipping-perk-banner').forEach(function (el) {
          var initial = parseInt(el.getAttribute('data-initial-total'), 10) || 0;
          renderBanner(el, initial);
        });
      });
  }

  // 初期描画（Liquidの initial total で即時）→ 直後に最新へ更新
  function initialRender() {
    document.querySelectorAll('.shipping-perk-banner').forEach(function (el) {
      var initial = parseInt(el.getAttribute('data-initial-total'), 10) || 0;
      renderBanner(el, initial);
    });
    setTimeout(refreshAllBanners, 0);
  }

  // Ajax更新をざっくり検知
  function wireEvents() {
    document.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'updates[]' || e.target.name === 'quantity' || e.target.type === 'number')) {
        setTimeout(refreshAllBanners, 400);
      }
    });

    document.addEventListener('click', function (e) {
      var el = e.target.closest('button, [type="submit"], a');
      if (!el) return;
      var hint = (el.name || '') + ' ' + (el.className || '') + ' ' + (el.getAttribute('href') || '');
      if (/update|cart|quantity|plus|minus|remove|add|drawer|ajax/i.test(hint)) {
        setTimeout(refreshAllBanners, 600);
      }
    });

    // ミニカートの開閉/再描画（DOM差し替え）に追従
    var observer = new MutationObserver(function (mutations) {
      var shouldRefresh = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes || [], function (n) {
          return n && n.nodeType === 1 && (
            (n.matches && (n.matches('#CartDrawer, .ajaxcart, .AjaxCart, .cart-drawer'))) ||
            (n.querySelector && n.querySelector('.shipping-perk-banner'))
          );
        });
      });
      if (shouldRefresh) setTimeout(refreshAllBanners, 200);
    });
    observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialRender();
      wireEvents();
    });
  } else {
    initialRender();
    wireEvents();
  }
})();
